import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  input,
  viewChild,
} from '@angular/core';
import { LiveStream } from 'src/app/interfaces/live-stream.interface';
import * as Hammer from 'hammerjs';
import Hls from 'hls.js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LoaderComponent } from '../loader/loader.component';
import { DivClickDirective } from 'src/app/directives/div-click.directive';

@Component({
  selector: 'app-live-stream',
  templateUrl: './live-stream.component.html',
  standalone: true,
  imports: [TranslateModule, DivClickDirective, NgIf, InlineSVGModule],
})
export class LiveStreamComponent implements OnInit {
  readonly holder = viewChild<ElementRef>('holder');
  readonly video = viewChild<ElementRef>('video');
  readonly iframe = viewChild<ElementRef>('iframe');
  public readonly liveStreams = input<LiveStream[]>(undefined);

  public currentLiveStream: LiveStream;
  public currentIndex = 0;

  public showError: boolean = false;
  public started: boolean = false;
  public loading: boolean = false;
  public iframeUrl: SafeResourceUrl;

  constructor(private cd: ChangeDetectorRef, private sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this.currentLiveStream = this.liveStreams()[this.currentIndex];
    if (this.currentLiveStream.iframe) {
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.liveStreams()[this.currentIndex].url + '?autoplay=1'
      );
    } else {
      const videoElement: HTMLVideoElement = this.video()?.nativeElement;
      if (videoElement) {
        this.showError =
          videoElement.canPlayType('application/x-mpegURL') === '' &&
          !Hls.isSupported();
      }
    }
  }

  setStarted(value: boolean) {
    this.started = value;
  }

  startStream() {
    this.setStarted(true);
    this.start();
  }

  start() {
    if (this.currentLiveStream.iframe) {
      return;
    }
    const videoElement = this.video().nativeElement;
    this.loading = true;

    if (Hls.isSupported()) {
      const hls = new Hls();

      if (!this.currentLiveStream.iframe) {
        hls.loadSource(this.currentLiveStream.url);
      }

      hls.attachMedia(videoElement);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoElement.play();
        this.loading = false;
        this.cd.detectChanges();
      });
    } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
      if (!this.currentLiveStream.iframe) {
        videoElement.src = this.currentLiveStream.url;
      }

      videoElement.addEventListener('loadedmetadata', () => {
        videoElement.play();
        this.loading = false;
        this.cd.detectChanges();
      });
    }
  }
}
